export default __webpack_public_path__ + "static/media/info-circle.96f64cda.svg";